import { render, staticRenderFns } from "./InvoiceAddressPicker.vue?vue&type=template&id=60650bd8"
import script from "./InvoiceAddressPicker.vue?vue&type=script&lang=js"
export * from "./InvoiceAddressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports